// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mmyCM","actions":"styles_actions__PMONW"};